import { useState } from 'react';
import { useAuthStore } from '../store/auth';
import toast from 'react-hot-toast';

function Profile() {
  const { user, updateProfile, logout, isLoading } = useAuthStore();

  const [formData, setFormData] = useState({
    full_name: user?.full_name || '',
    email: user?.email || '',
  });

  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const handleProfileChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordData((prev) => ({ ...prev, [name]: value }));
  };

  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    const result = await updateProfile(formData);
    if (result.success) {
      toast.success('Profile updated successfully');
    } else {
      toast.error(result.error);
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    // TODO: Implement password change API call
    toast.error('Password change not implemented yet');
  };

  const handleLogout = async () => {
    await logout();
    toast.success('Logged out successfully');
  };

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="text-3xl font-bold mb-8">Profile Settings</h1>

      {/* Profile Info */}
      <div className="card mb-8">
        <h2 className="text-xl font-semibold mb-4">Account Information</h2>
        
        <form onSubmit={handleProfileSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-2">Full Name</label>
            <input
              type="text"
              name="full_name"
              value={formData.full_name}
              onChange={handleProfileChange}
              className="input"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium mb-2">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleProfileChange}
              className="input"
            />
          </div>

          <button type="submit" className="btn btn-primary" disabled={isLoading}>
            {isLoading ? 'Saving...' : 'Save Changes'}
          </button>
        </form>
      </div>

      {/* Account Status */}
      <div className="card mb-8">
        <h2 className="text-xl font-semibold mb-4">Account Status</h2>
        
        <div className="space-y-3">
          <div className="flex justify-between">
            <span className="text-gray-400">Role</span>
            <span className="capitalize">{user?.role || 'user'}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-400">Status</span>
            <span className={user?.is_active ? 'text-green-400' : 'text-red-400'}>
              {user?.is_active ? 'Active' : 'Inactive'}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-400">Email Verified</span>
            <span className={user?.is_verified ? 'text-green-400' : 'text-yellow-400'}>
              {user?.is_verified ? 'Verified' : 'Not Verified'}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-400">Member Since</span>
            <span>{user?.created_at ? new Date(user.created_at).toLocaleDateString() : '-'}</span>
          </div>
        </div>
      </div>

      {/* Change Password */}
      <div className="card mb-8">
        <h2 className="text-xl font-semibold mb-4">Change Password</h2>
        
        <form onSubmit={handlePasswordSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-2">Current Password</label>
            <input
              type="password"
              name="currentPassword"
              value={passwordData.currentPassword}
              onChange={handlePasswordChange}
              className="input"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium mb-2">New Password</label>
            <input
              type="password"
              name="newPassword"
              value={passwordData.newPassword}
              onChange={handlePasswordChange}
              className="input"
              minLength={8}
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium mb-2">Confirm New Password</label>
            <input
              type="password"
              name="confirmPassword"
              value={passwordData.confirmPassword}
              onChange={handlePasswordChange}
              className="input"
            />
          </div>

          <button type="submit" className="btn btn-secondary">
            Change Password
          </button>
        </form>
      </div>

      {/* Danger Zone */}
      <div className="card border-red-500/50">
        <h2 className="text-xl font-semibold mb-4 text-red-400">Danger Zone</h2>
        
        <div className="flex items-center justify-between">
          <div>
            <p className="font-medium">Log Out</p>
            <p className="text-sm text-gray-400">Sign out of your account</p>
          </div>
          <button onClick={handleLogout} className="btn btn-secondary">
            Log Out
          </button>
        </div>
      </div>
    </div>
  );
}

export default Profile;
